module.exports = __webpack_public_path__ + "img/pic6.709b9829.png";